import { render, staticRenderFns } from "./GroupedShiftMealsTable.vue?vue&type=template&id=16eb4e84&scoped=true"
import script from "./GroupedShiftMealsTable.vue?vue&type=script&lang=js"
export * from "./GroupedShiftMealsTable.vue?vue&type=script&lang=js"
import style0 from "./GroupedShiftMealsTable.vue?vue&type=style&index=0&id=16eb4e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eb4e84",
  null
  
)

export default component.exports